module.exports = __webpack_public_path__ + "img/24.9e2a5c76.jpg";